import { Tab } from "@headlessui/react";
import countrySearch from "lib/helpers/countrySearch";
import formatObjectWithKeysAsArray from "lib/helpers/formatObjectWithKeysAsArray";
import apiData from "lib/stores/apiData";
import DataPanelWrapper from "./DataPanelWrapper";
import context from "lib/stores/context";
import { useEffect, useState } from "react";
import { useSnapshot } from "valtio";
import DetailsPaneTable from "components/common/DetailsPane/DetailsPaneTable";
import SidebarSearch from "components/Sidebar/SidebarSearch";

const CountriesPanel = () => {
  const { countries } = useSnapshot(apiData, { sync: true });
  const { searchQuery, activeTabWorldwide, activeTabRegions, activeRegion } = useSnapshot(context, { sync: true });
  const [countriesArray, setCountriesArray] = useState([]);
  const [queryResults, setQueryResults] = useState([]);

  useEffect(() => {
    if (!searchQuery) {
      setQueryResults([]);
    }
    const results = countrySearch.search(searchQuery, { prefix: true });
    setQueryResults([...results]);
  }, [searchQuery]);

  useEffect(() => {
    countrySearch.removeAll();
    let countriesArr = formatObjectWithKeysAsArray(countries);
    if (activeRegion) {
      countriesArr = countriesArr.filter(country => country.region_id === activeRegion);
    }
    setCountriesArray(countriesArr);
    countrySearch.addAll(countriesArr);
  }, [countries, activeRegion]);

  return (
    <DataPanelWrapper isMounted={() => activeTabWorldwide === 0 || activeTabRegions === 0}>
      <SidebarSearch />
      <DetailsPaneTable rows={countriesArray} queryResults={queryResults} />
    </DataPanelWrapper>
  );
};

export default CountriesPanel;
